// ── the version the header shows ───────────────────────────────────
//
// It is not its own number. It is PROTOCOL_VERSION, shortened.
//
// The header used to read "v5.0" as a literal while the instrument was running
// v6.0.1-dev, because a display string and a protocol constant are two places
// and two places drift. There is one number here: `api/mirror.js` declares
// PROTOCOL_VERSION, `GET /api/mirror` reports it, and this shortens whatever
// came back for the chip beside the title.
//
// Reporting the SERVER's value rather than a constant compiled into the client
// is the point. A build talking to an older deployment then shows the older
// number instead of hiding the mismatch behind a label it printed itself —
// the same reason a reading carries the snapshot it was measured against.
//
// Anything unparseable returns null and the chip renders nothing. A version is
// a claim about which instrument produced a reading; a guessed one is worse
// than an absent one.
// ── the version the RECORD carries ─────────────────────────────────
//
// A different question from the one above, and the reason it gets its own
// constant despite everything this file says about compiled-in numbers.
// protocolVersion names the contract that produced a reading; it did not move
// for v6.1 because api/mirror.js did not. So a v6.1 record and a v6.0.2 record
// stamp the same protocol, and nothing in the file says which client did the
// arranging — the difference that start/phase/edits/origin all live on.
// start:"open" is circumstantial; this is the fact.
//
// The hazard this file warns about is real and applies here: a literal drifts
// the moment a deploy forgets it, which is exactly how the header once read
// "v5.0" against a v6.0.1-dev instrument. So it is checked rather than trusted
// — scripts/verify-6-1-session.mjs fails if HEAD is tagged and the tag and this
// string disagree. Bump it in the same commit as the tag, or the check catches
// it before the deploy does not.
export const CLIENT_VERSION = "v6.1.6";

export function displayVersion(protocolVersion) {
  if (typeof protocolVersion !== "string") return null;
  // Anchored at the start on purpose (rule 18): an unanchored match would
  // happily find "v1.2" inside "claude-opus-4-5" or a trailing build tag.
  const m = /^v(\d+)\.(\d+)(?:[.\-+]|$)/.exec(protocolVersion.trim());
  return m ? `v${m[1]}.${m[2]}` : null;
}
